import { getDisplayWidth, MOBILE_WIDTH } from '../utils/helpers.js';


var ctx = document.getElementById('chart').getContext('2d');

function drawChart(chart) {
    let datasets = [];
    let baseDataset = {
        showLine: true,
        lineTension: 0,
        borderWidth: 5,
        fill: false,
    }
    let legendShowed = false;

    if(Array.isArray(chart)) {
        legendShowed = true;
        for(let dataset of chart){
            datasets.push(
                Object.assign(
                    {
                        label: dataset.header,
                        backgroundColor: dataset.line_color,
                        borderColor: dataset.line_color,
                        pointBackgroundColor: dataset.point_color,
                        pointBorderColor: dataset.point_color,
                        data: dataset.data
                    },
                    baseDataset
                )
            )
        }
    } else {
        datasets.push(
            Object.assign(
                {
                    label: chart.header,
                    backgroundColor: chart.line_color,
                    borderColor: chart.line_color,
                    pointBackgroundColor: chart.point_color,
                    pointBorderColor: chart.point_color,
                    data: chart.data
                },
                baseDataset
            )
        );
    }
    var myChart = new Chart(ctx, {
        type: 'scatter',
        data: {
            // datasets: [{
            //     label: '111',
            //     showLine: true,
            //     backgroundColor: '#134995',
            //     borderColor: '#134995',
            //     pointBackgroundColor: '#fdc500',
            //     pointBorderColor: '#fdc500',
            //     lineTension: 0,
            //     borderWidth: 5,
            //     data: data,
            //     fill: false,
            // }]
            datasets: datasets,
        },
        options: {
            responsive: true,
            legend: {
                display: legendShowed
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontColor: 'gray',
                        fontSize: 18,
                        fontFamily: 'GothamPro',
                        autoSkip: true,
                        maxTicksLimit: 6
                    }
                }],
                yAxes: [{
                    display: false,
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            layout: {
                padding: {
                    left: 0,
                    right: 20,
                    top: 50,
                    bottom: 0
                }
            },
                
        },
        plugins: [{
            afterDatasetsDraw: function(chart) {
              var ctx = chart.ctx;
              chart.data.datasets.forEach(function(dataset, index) {
                 var datasetMeta = chart.getDatasetMeta(index);
                 if (datasetMeta.hidden) return;
                 datasetMeta.data.forEach(function(point, index) {
                    var value = dataset.data[index].y,
                        x = point.getCenterPoint().x,
                        y = point.getCenterPoint().y,
                        radius = point._model.radius,
                        fontSize = 18,
                        fontFamily = 'GothamPro',
                        fontColor = 'black',
                        fontStyle = 'normal';
                    ctx.save();
                    ctx.textBaseline = 'middle';
                    ctx.textAlign = 'center';
                    ctx.font = fontStyle + ' ' + fontSize + 'px' + ' ' + fontFamily;
                    ctx.fillStyle = fontColor;
                    ctx.fillText(value, x, y - radius - fontSize);
                    ctx.restore();
                 });
              });
            }
        }],
    });
}
// drawChart(data);

function updateChart(id){
    let url = '/api/aboutpagechart/';
    if(id){
        url += id + '/';
    }
    $.ajax({
        url: url
    }).done(function(response){
        if(response) {
            drawChart(response);
        }
    });
}

updateChart();

$('.js-chart').click(function(){
    var $el = $(this);
    updateChart($el.data('id'));
    $('.js-chart').removeClass('about__numbers-link_active');
    $el.addClass('about__numbers-link_active');
});

$('.js-chart-select').change(function(){
    var $el = $(this);
    updateChart($el.val())
});


$('.service__slider_1').slick({
    speed: 1000,
    arrows: false,
    dots: true,
    touchThreshold: 10,
    asNavFor: '.service__slider_2'
});

$('.service__slider_2').slick({
    speed: 1000,
    arrows: false,
    fade: true,
    touchThreshold: 10,
    asNavFor: '.service__slider_1'
});

$('.about-slider-mobile').slick({
    speed: 1000,
    arrows: false,
    dots: true,
    touchThreshold: 10,
    slidesToShow: 1,
});


$('.js-about-year').on('click', function () {
    var $el = $(this);
    var $rail = $el.closest('._active-box');
    let scrollLeft = $el.offset().left - $rail.offset().left - 30;
    $rail.find('.js-about-year').removeClass('_active');
    $el.addClass('_active');

    if(getDisplayWidth() > MOBILE_WIDTH) {
        scrollLeft -= 120;

        if(!$el.hasClass('_first')) {
            scrollLeft -= 200;
        }
    }

        
    $('.about__time-wrap').animate({scrollLeft: scrollLeft}); // .scrollLeft($el.offset().left - $rail.offset().left - 150);
});



// WEBPACK FOOTER //
// ./js/pages/about.js